import React, { PropTypes, Component } from 'react';
import classes from '../index.scss';
import cx from 'classNames';
import Cookie from 'modules/cookie';
import Initial from './Initial';
import Success from './Success';
import Invalid from './Invalid';
import { cookieModal, stages } from '../lib/constants';

class Modal extends Component {
  state = {
    close: false,
    stage: stages.Initial,
  }

  event = (nextStage) => {
    if (nextStage === stages.Close) {
      this.setState({ close: true });
      Cookie.set(cookieModal.name, cookieModal.value, 1);
    } else {
      this.setState({ stage: nextStage });
    }
  }

  render() {
    const components = {
      Initial,
      Success,
      Invalid,
    };
    const initialProps = { callback: this.event };
    const stage = this.state.stage;
    const props = stage === stages.Initial ?
      { ...initialProps, csrfToken: this.props.csrfToken } :
      initialProps;
    const ComponentForStage = components[stage];
    const visibility = cx({
      [classes.hide]: this.state.close,
    });
    const action = this.state.close ? '' : 'hidden';
    document.body.style.overflow = action;

    return(
      <div className={`${classes.main} ${visibility}`}>
        <div className={classes.modal}>
          <ComponentForStage {...props} />
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  csrfToken: PropTypes.string.isRequired,
};

export default Modal;



/** WEBPACK FOOTER **
 ** ./apps/emailPromoModal/components/Modal.js
 **/